export enum TEAM_OWNER_ACTION {
  INVITE_MEMBER = 'invite-member',
  REMOVE_MEMBER = 'remove-member',
  ASSIGN_ADMIN = 'assign-admin',
  REMOVE_ADMIN = 'remove-admin',
  CREATE_NAME = 'create-name',
  MASS_UPDATES = 'mass-updates',
  ADD_MEMBER_MANUALLY = 'add-member-manually'
}

/**
 * School-level member standing sent to `invite-member` / `add-member-manually`
 * (`role`) and derived from the all-members `admins[]` / `teachers[]` arrays.
 */
export enum TEAM_MEMBER_ROLE {
  ADMIN = 'admin',
  TEACHER = 'teacher',
  MEMBER = 'member'
}

/**
 * How the current user can access a team returned by
 * `GET team-management/admin-teams?include_teaching=true`.
 */
export enum TEAM_ACCESS_ROLE {
  ADMIN = 'admin',
  TEACHER = 'teacher'
}

/** Start vs end bound on the teacher class-session window timeline (admin UI). */
export enum CLASS_SESSION_WINDOW_BOUND {
  START = 'start',
  END = 'end'
}

/** Role filter on the school team members list (All / Teachers / Students / Admins). */
export enum SCHOOL_MEMBER_FILTER {
  ALL = 'all',
  TEACHERS = 'teachers',
  STUDENTS = 'students',
  ADMINS = 'admins'
}

export enum InvitationStatus {
  FAILED = 'failed',
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
  EXPIRED = 'expired'
}

export enum INVITATION_STATUS {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  EXPIRED = 'expired'
}

export enum UNLOCK_REQUEST_STATUS {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
  /** Class mode: the AI allowed it after the student's explanation (per-student, time-boxed). */
  AI_APPROVED = 'ai_approved',
  /** Class mode: the AI kept it blocked after the student's explanation. */
  AI_REJECTED = 'ai_rejected'
}

export enum UNLOCK_REQUEST_ROLE {
  SENT = 'sent',
  RECEIVED = 'received'
}

/** Sortable columns of the principal staff-usage table; all but NAME are `StaffUsageRow` fields. */
export enum StaffUsageSortKey {
  NAME = 'name',
  DAYS_USED = 'focus_modes_pct_days_used',
  FOCUS_HOURS = 'total_focused_hours',
  FOCUS_MODES = 'focus_modes_completed',
  CLASS_SESSIONS = 'class_sessions_run',
  STREAK = 'focus_modes_streak'
}
